/* (ignored) */


//////////////////
// WEBPACK FOOTER
// xmlhttprequest (ignored)
// module id = 2
// module chunks = 0